// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // apiUrl: 'http://127.0.0.1:8000/api/',
  // production: false,
  apiUrl: 'https://apiv2.argenfil.com.ar/api/',
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyBYDRZco4bk9_quFvn33tVOM0-zuvE4ViU',
    authDomain: 'argenfil-a2a87.firebaseapp.com',
    projectId: 'argenfil-a2a87',
    storageBucket: 'argenfil-a2a87.appspot.com',
    messagingSenderId: '44818070118',
    appId: '1:44818070118:web:c00997f4cbc74d0bffcba7',
    measurementId: 'G-7JLEHF8DRE',
  },
};

// export const environment = {
//   production: false,
//   apiUrl: 'https://apiv2.argenfil.com.ar/api/',
//   firebaseConfig: {
//     apiKey: "AIzaSyBYDRZco4bk9_quFvn33tVOM0-zuvE4ViU",
//     authDomain: "argenfil-a2a87.firebaseapp.com",
//     projectId: "argenfil-a2a87",
//     storageBucket: "argenfil-a2a87.appspot.com",
//     messagingSenderId: "44818070118",
//     appId: "1:44818070118:web:c00997f4cbc74d0bffcba7",
//     measurementId: "G-7JLEHF8DRE"
//   }
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
